import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { api } from '../services/api';
import Header from '../components/Header';
import SongPortal from '../components/SongPortal';

export default function RoomPage() {
  const { code } = useParams();
  const navigate = useNavigate();
  const [room, setRoom] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    api.getRoom(code.toUpperCase()).then(setRoom).catch(() => setNotFound(true));
  }, [code]);

  if (notFound) {
    return (
      <div className="app-shell">
        <Header />
        <div className="loading-screen">
          <div style={{fontSize:48}}>😕</div>
          <p style={{color:'var(--text2)'}}>Комната не найдена или устарела.</p>
          <button className="btn btn-primary" onClick={() => navigate('/')}>На главную</button>
        </div>
      </div>
    );
  }

  if (!room) {
    return (
      <div className="app-shell">
        <Header />
        <div className="loading-screen"><div className="spinner lg" /><span>Входим в комнату...</span></div>
      </div>
    );
  }

  return (
    <div className="app-shell">
      <Header roomCode={room.code} subtitle={room.name} />
      <SongPortal roomCode={room.code} isDj={false} />
    </div>
  );
}
